// ─── NEDERLANDS ────────────────────────────────────────────────────────────
const T_NL = {
  motto: "Horen om te weten waar je bent,\nkijken om te zien waarheen je gaat.",
  sim: "SIMULATIE",
  gpsLive: "GPS LIVE",
  addPoi: "+ POI",
  import: "Import",
  export: "Export",
  clear: "Wis",
  confirm: "Bevestig",
  cancel: "Annuleer",
  search: "Naam of Pluscode\u2026",
  noPois: "Geen POI's gevonden",
  settings: "Instellingen",
  userId: "Gebruikers-ID",
  languages: "Talen",
  eleven: "ElevenLabs Config",
  editPoi: "POI Bewerken",
  name: "Naam",
  desc: "Beschrijving",
  cat: "Categorie",
  radius: "Straal (m)",
  save: "Opslaan",
  clearDb: "Database wissen?",
  routeMenu: "Route & Track",
  loadGpx: "GPX Laden",
  startRec: "Start Opname",
  stopRec: "Stop Opname",
  saveTrack: "Opslaan",
  clearTrack: "Wis Track",
  trackOn: "OPNEMEN",
  trackPause: "GEPAUZEERD",
  trackOff: "GESTOPT",
  pluscode: "Pluscode",
  osm: "OSM",
  sat: "SAT",
  copyLogs: "Logs kopi\u00EBren",
  clearLogs: "Logs wissen",
  target: "PRIKPUNT",
  photo: "Foto",
  audio: "Audio",
  browseAudio: "Lokaal bestand",
  sysInfo: "Systeem Logs",
  meter: "meter",
  transport_label: "Vervoersmiddel",
  announce: (n, d, c) => `${n}. Op ${Math.round(d)} meter. Op ${c} uur.`,
  aboutTitle: "Over EuroPoi",
  aboutText: "Ontwerp: Peter Drukker\n\u00A9 2026\nduyfje@icloud.com",
  stopSpeech: "STOP SPRAAK",
  pin: "Pincode Invoeren",
  adminOn: "ADMIN MODUS ACTIEF",
  adminOff: "TOEGANG GEWEIGERD",
  offline: "OFFLINE",
  pinHint: "4-cijferige code",
  audioHierarchy: "Spraakhi\u00EBrarchie",
  audioSrc1: "1 \u00B7 CSV/URL (online)",
  audioSrc2: "2 \u00B7 Bulk (pluscode)",
  audioSrc3: "3 \u00B7 Individueel bestand",
  audioSrc4: "4 \u00B7 ElevenLabs TTS",
  audioSrc5: "5 \u00B7 Browser stem",
  bulkTitle: "Bulk Audio (MP3/WAV)",
  bulkHint: "Bestandsnaam = Pluscode (bijv. 9F4M3Q22+XX.mp3)",
  bulkBtn: "Bestanden Selecteren",
  bulkResult: (n) => `${n} bestand(en) gekoppeld`,
  bulkOverwrite: "Bestaande koppelingen worden overschreven",
};

// ─── ENGLISH ───────────────────────────────────────────────────────────────
const T_EN = {
  ...T_NL,
  motto: "Hear to know where you are,\nlook to see where you're going.",
  sim: "SIMULATION",
  gpsLive: "GPS LIVE",
  addPoi: "+ POI",
  import: "Import",
  export: "Export",
  clear: "Clear",
  confirm: "Confirm",
  cancel: "Cancel",
  search: "Name or Pluscode\u2026",
  noPois: "No POIs found",
  settings: "Settings",
  userId: "User ID",
  languages: "Languages",
  eleven: "ElevenLabs Config",
  editPoi: "Edit POI",
  name: "Name",
  desc: "Description",
  cat: "Category",
  radius: "Radius (m)",
  save: "Save",
  clearDb: "Clear database?",
  routeMenu: "Route & Track",
  loadGpx: "Load GPX",
  startRec: "Start Recording",
  stopRec: "Stop Recording",
  saveTrack: "Save",
  clearTrack: "Clear Track",
  trackOn: "RECORDING",
  trackPause: "PAUSED",
  trackOff: "STOPPED",
  copyLogs: "Copy Logs",
  clearLogs: "Clear Logs",
  target: "TARGET",
  photo: "Photo",
  audio: "Audio",
  browseAudio: "Local file",
  sysInfo: "System Logs",
  meter: "meters",
  transport_label: "Transport Mode",
  announce: (n, d, c) => `${n}. At ${Math.round(d)} meters. At ${c} o'clock.`,
  aboutTitle: "About EuroPoi",
  aboutText: "Design: Peter Drukker\n\u00A9 2026\nduyfje@icloud.com",
  stopSpeech: "STOP SPEECH",
  pin: "Enter PIN",
  adminOn: "ADMIN MODE ACTIVE",
  adminOff: "ACCESS DENIED",
  offline: "OFFLINE",
  pinHint: "4-digit code",
  audioHierarchy: "Audio Hierarchy",
  audioSrc1: "1 \u00B7 CSV/URL (online)",
  audioSrc2: "2 \u00B7 Bulk (pluscode)",
  audioSrc3: "3 \u00B7 Individual file",
  audioSrc4: "4 \u00B7 ElevenLabs TTS",
  audioSrc5: "5 \u00B7 Browser voice",
  bulkTitle: "Bulk Audio (MP3/WAV)",
  bulkHint: "Filename = Pluscode (e.g. 9F4M3Q22+XX.mp3)",
  bulkBtn: "Select Files",
  bulkResult: (n) => `${n} file(s) linked`,
  bulkOverwrite: "Existing links will be overwritten",
};

// ─── DEUTSCH ───────────────────────────────────────────────────────────────
const T_DE = {
  ...T_EN,
  motto:
    "H\u00F6ren um zu wissen wo du bist,\nschauen um zu sehen wohin du gehst.",
  sim: "SIMULATION",
  clear: "L\u00F6schen",
  confirm: "Best\u00E4tigen",
  cancel: "Abbrechen",
  search: "Name oder Pluscode\u2026",
  noPois: "Keine POIs gefunden",
  settings: "Einstellungen",
  userId: "Benutzer-ID",
  languages: "Sprachen",
  editPoi: "POI bearbeiten",
  name: "Name",
  desc: "Beschreibung",
  cat: "Kategorie",
  save: "Speichern",
  clearDb: "Datenbank l\u00F6schen?",
  routeMenu: "Route & Track",
  loadGpx: "GPX laden",
  startRec: "Aufnahme starten",
  stopRec: "Aufnahme stoppen",
  saveTrack: "Speichern",
  clearTrack: "Track l\u00F6schen",
  trackOn: "AUFNAHME",
  trackPause: "PAUSIERT",
  trackOff: "GESTOPPT",
  copyLogs: "Logs kopieren",
  clearLogs: "Logs l\u00F6schen",
  target: "ZIELPUNKT",
  browseAudio: "Lokale Datei",
  sysInfo: "System-Logs",
  meter: "Meter",
  transport_label: "Fortbewegungsmittel",
  announce: (n, d, c) => `${n}. In ${Math.round(d)} Metern. Auf ${c} Uhr.`,
  aboutTitle: "\u00DCber EuroPoi",
  aboutText: "Entwurf: Peter Drukker\n\u00A9 2026\nduyfje@icloud.com",
  stopSpeech: "SPRACHE STOPPEN",
  pin: "PIN eingeben",
  adminOn: "ADMIN-MODUS AKTIV",
  adminOff: "ZUGANG VERWEIGERT",
  offline: "OFFLINE",
  pinHint: "4-stelliger Code",
  audioHierarchy: "Sprachhierarchie",
  audioSrc2: "2 \u00B7 Bulk (Pluscode)",
  audioSrc3: "3 \u00B7 Einzelne Datei",
  audioSrc5: "5 \u00B7 Browser-Stimme",
  bulkTitle: "Bulk-Audio (MP3/WAV)",
  bulkHint: "Dateiname = Pluscode (z.B. 9F4M3Q22+XX.mp3)",
  bulkBtn: "Dateien ausw\u00E4hlen",
  bulkResult: (n) => `${n} Datei(en) verkn\u00FCpft`,
  bulkOverwrite: "Bestehende Verkn\u00FCpfungen werden \u00FCberschrieben",
};

// ─── FRANÇAIS ──────────────────────────────────────────────────────────────
const T_FR = {
  ...T_EN,
  motto:
    "Entendre pour savoir o\u00F9 vous \u00EAtes,\nregarder pour voir o\u00F9 vous allez.",
  sim: "SIMULATION",
  gpsLive: "GPS EN DIRECT",
  import: "Importer",
  export: "Exporter",
  clear: "Effacer",
  confirm: "Confirmer",
  cancel: "Annuler",
  search: "Nom ou Pluscode\u2026",
  noPois: "Aucun POI trouv\u00E9",
  settings: "Param\u00E8tres",
  userId: "ID utilisateur",
  languages: "Langues",
  eleven: "Config ElevenLabs",
  editPoi: "Modifier POI",
  name: "Nom",
  desc: "Description",
  cat: "Cat\u00E9gorie",
  radius: "Rayon (m)",
  save: "Enregistrer",
  clearDb: "Effacer la base de donn\u00E9es\u00A0?",
  routeMenu: "Route & Trace",
  loadGpx: "Charger GPX",
  startRec: "D\u00E9marrer enregistrement",
  stopRec: "Arr\u00EAter enregistrement",
  saveTrack: "Enregistrer",
  clearTrack: "Effacer la trace",
  trackOn: "ENREGISTREMENT",
  trackPause: "EN PAUSE",
  trackOff: "ARR\u00CATE",
  copyLogs: "Copier les logs",
  clearLogs: "Effacer les logs",
  target: "POINT CIBLE",
  photo: "Photo",
  browseAudio: "Fichier local",
  sysInfo: "Logs syst\u00E8me",
  meter: "m\u00E8tres",
  transport_label: "Mode de transport",
  announce: (n, d, c) =>
    `${n}. \u00C0 ${Math.round(d)} m\u00E8tres. \u00C0 ${c} heures.`,
  aboutTitle: "\u00C0 propos de EuroPoi",
  aboutText: "Conception\u00A0: Peter Drukker\n\u00A9 2026\nduyfje@icloud.com",
  stopSpeech: "STOPPER AUDIO",
  pin: "Entrer le PIN",
  adminOn: "MODE ADMIN ACTIF",
  adminOff: "ACC\u00C8S REFUS\u00C9",
  offline: "HORS LIGNE",
  pinHint: "Code \u00E0 4 chiffres",
  audioHierarchy: "Hi\u00E9rarchie audio",
  audioSrc1: "1 \u00B7 CSV/URL (en ligne)",
  audioSrc3: "3 \u00B7 Fichier individuel",
  audioSrc5: "5 \u00B7 Voix navigateur",
  bulkTitle: "Audio en masse (MP3/WAV)",
  bulkHint: "Nom de fichier = Pluscode (ex. 9F4M3Q22+XX.mp3)",
  bulkBtn: "S\u00E9lectionner des fichiers",
  bulkResult: (n) => `${n} fichier(s) li\u00E9(s)`,
  bulkOverwrite: "Les liens existants seront \u00E9cras\u00E9s",
};

// ─── ESPAÑOL ───────────────────────────────────────────────────────────────
const T_ES = {
  ...T_EN,
  motto:
    "O\u00EDr para saber d\u00F3nde est\u00E1s,\nmirar para ver ad\u00F3nde vas.",
  sim: "SIMULACI\u00D3N",
  gpsLive: "GPS EN VIVO",
  import: "Importar",
  export: "Exportar",
  clear: "Borrar",
  confirm: "Confirmar",
  cancel: "Cancelar",
  search: "Nombre o Pluscode\u2026",
  noPois: "No se encontraron POIs",
  settings: "Ajustes",
  userId: "ID de usuario",
  languages: "Idiomas",
  eleven: "Config ElevenLabs",
  editPoi: "Editar POI",
  name: "Nombre",
  desc: "Descripci\u00F3n",
  cat: "Categor\u00EDa",
  radius: "Radio (m)",
  save: "Guardar",
  clearDb: "\u00BFBorrar base de datos?",
  routeMenu: "Ruta y traza",
  loadGpx: "Cargar GPX",
  startRec: "Iniciar grabaci\u00F3n",
  stopRec: "Detener grabaci\u00F3n",
  saveTrack: "Guardar",
  clearTrack: "Borrar traza",
  trackOn: "GRABANDO",
  trackPause: "EN PAUSA",
  trackOff: "DETENIDO",
  copyLogs: "Copiar registros",
  clearLogs: "Borrar registros",
  target: "PUNTO OBJETIVO",
  photo: "Foto",
  browseAudio: "Archivo local",
  sysInfo: "Registros del sistema",
  meter: "metros",
  transport_label: "Modo de transporte",
  announce: (n, d, c) =>
    `${n}. A ${Math.round(d)} metros. A las ${c} en punto.`,
  aboutTitle: "Acerca de EuroPoi",
  aboutText: "Dise\u00F1o: Peter Drukker\n\u00A9 2026\nduyfje@icloud.com",
  stopSpeech: "DETENER AUDIO",
  pin: "Introducir PIN",
  adminOn: "MODO ADMIN ACTIVO",
  adminOff: "ACCESO DENEGADO",
  offline: "SIN CONEXI\u00D3N",
  pinHint: "C\u00F3digo de 4 d\u00EDgitos",
  audioHierarchy: "Jerarqu\u00EDa de audio",
  audioSrc1: "1 \u00B7 CSV/URL (en l\u00EDnea)",
  audioSrc3: "3 \u00B7 Archivo individual",
  audioSrc5: "5 \u00B7 Voz del navegador",
  bulkTitle: "Audio masivo (MP3/WAV)",
  bulkHint: "Nombre de archivo = Pluscode (ej. 9F4M3Q22+XX.mp3)",
  bulkBtn: "Seleccionar archivos",
  bulkResult: (n) => `${n} archivo(s) vinculado(s)`,
  bulkOverwrite: "Los enlaces existentes ser\u00E1n sobrescritos",
};

// ─── ITALIANO ──────────────────────────────────────────────────────────────
const T_IT = {
  ...T_EN,
  motto: "Ascoltare per sapere dove sei,\nguardare per vedere dove vai.",
  sim: "SIMULAZIONE",
  gpsLive: "GPS IN DIRETTA",
  import: "Importa",
  export: "Esporta",
  clear: "Cancella",
  confirm: "Conferma",
  cancel: "Annulla",
  search: "Nome o Pluscode\u2026",
  noPois: "Nessun POI trovato",
  settings: "Impostazioni",
  userId: "ID utente",
  languages: "Lingue",
  eleven: "Config ElevenLabs",
  editPoi: "Modifica POI",
  name: "Nome",
  desc: "Descrizione",
  cat: "Categoria",
  radius: "Raggio (m)",
  save: "Salva",
  clearDb: "Cancellare il database?",
  routeMenu: "Percorso e traccia",
  loadGpx: "Carica GPX",
  startRec: "Avvia registrazione",
  stopRec: "Ferma registrazione",
  saveTrack: "Salva",
  clearTrack: "Cancella traccia",
  trackOn: "REGISTRAZIONE",
  trackPause: "IN PAUSA",
  trackOff: "FERMATO",
  copyLogs: "Copia log",
  clearLogs: "Cancella log",
  target: "PUNTO TARGET",
  photo: "Foto",
  browseAudio: "File locale",
  sysInfo: "Log di sistema",
  meter: "metri",
  transport_label: "Mezzo di trasporto",
  announce: (n, d, c) => `${n}. A ${Math.round(d)} metri. Alle ore ${c}.`,
  aboutTitle: "Informazioni su EuroPoi",
  aboutText: "Progetto: Peter Drukker\n\u00A9 2026\nduyfje@icloud.com",
  stopSpeech: "FERMA AUDIO",
  pin: "Inserisci PIN",
  adminOn: "MODALIT\u00C0 ADMIN ATTIVA",
  adminOff: "ACCESSO NEGATO",
  offline: "NON IN LINEA",
  pinHint: "Codice a 4 cifre",
  audioHierarchy: "Gerarchia audio",
  audioSrc3: "3 \u00B7 File individuale",
  audioSrc5: "5 \u00B7 Voce del browser",
  bulkTitle: "Audio di massa (MP3/WAV)",
  bulkHint: "Nome file = Pluscode (es. 9F4M3Q22+XX.mp3)",
  bulkBtn: "Seleziona file",
  bulkResult: (n) => `${n} file collegato/i`,
  bulkOverwrite: "I collegamenti esistenti verranno sovrascritti",
};

// ─── LOOKUP ────────────────────────────────────────────────────────────────
const TRANSLATIONS = {
  "nl-NL": T_NL,
  "en-GB": T_EN,
  "de-DE": T_DE,
  "fr-FR": T_FR,
  "es-ES": T_ES,
  "it-IT": T_IT,
};

export const getT = (lang) => TRANSLATIONS[lang] || T_NL;
